import httpClient from "./httpClient";

class filterFieldService {
    async getFilterFields(channelGuid) {
        return httpClient(`/${channelGuid}/filter-fields`);
    }
}

export default new filterFieldService();